// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

var initialState = {
  show: true,
  timeout: 0,
  retries: 0
};

function reducer(state, action) {
  if (action === "Retry") {
    return {
            show: false,
            timeout: Math.imul(state.retries + 1 | 0, 1000),
            retries: state.retries + 1 | 0
          };
  } else {
    return {
            show: true,
            timeout: state.timeout,
            retries: state.retries
          };
  }
}

function use() {
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var onRetry = function (param) {
    dispatch("Retry");
  };
  React.useEffect((function () {
          if (state.show === false) {
            var id = setTimeout((function () {
                    dispatch("Show");
                  }), state.timeout);
            return (function () {
                      clearTimeout(id);
                    });
          }
          
        }), [state.show]);
  return [
          state.show,
          onRetry
        ];
}

export {
  initialState ,
  reducer ,
  use ,
}
/* react Not a pure module */
